// extracted by mini-css-extract-plugin
export default {"loader":"dashboard_map_loader__q5BWn"};